import gql from 'graphql-tag';
import {
  HasSharedWithFragment,
  ShareTargetFragment,
} from 'services/apollo/fragments/coreFragments';

export const ActivityFeedFragment = gql`
  fragment activityFeedResults on ActivityFeedSearch {
    nodes {
      ... on Node {
        id
        title
        baseUrl
        url
        modified
        created
        isIntegrationConnected
        integrationType
        category
        owners {
          id
          name
          email
          avatarUrl
        }
        ...hasSharedWith
        ...shareTargetResults @include(if: $includeGroups)
        sharingEnabled
        __typename
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
  ${HasSharedWithFragment},${ShareTargetFragment}
`;

// For plus button share window
export const NodeFragment = gql`
  fragment nodeFragmentResults on NodeType {
    ... on Node {
      id
      title
      baseUrl
      url
      modified
      created
      integrationType
      category
      owners {
        id
        name
        email
        avatarUrl
      }
      accessorInfo(includeGroups: $includeGroups) {
        accessors {
          ... on Group {
            id
            emoji
            groupName: name
          }
          ... on Person {
            id
            name
            email
            avatarUrl
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          total
        }
      }
      sharingEnabled
      __typename
    }
  }
`;

// For plus button share window
export const NodeFragmentWithGroups = gql`
  fragment nodeResults on NodeType {
    ... on Node {
      id
      title
      baseUrl
      url
      modified
      created
      integrationType
      category
      owners {
        id
        name
        email
        avatarUrl
      }
      shareTargets {
        nodeId @client
        groupTargets(first: 200) {
          nodeId @client
          targets {
            ... on ShareTargetGroup {
              __typename
              id
              emoji
              groupName: name
            }
            nodeId
          }
          pageInfo {
            total
          }
        }
        orgPeopleTargets(first: 200) {
          nodeId @client
          targets {
            ... on Person {
              __typename
              id
              name
              avatarUrl
            }
            nodeId @client
            isOrgMember
          }
          pageInfo {
            total
          }
        }
        otherPeopleTargets(first: 200) {
          nodeId @client
          targets {
            ... on Person {
              __typename
              id
              name
              avatarUrl
            }
            nodeId @client
            isOrgMember
          }
          pageInfo {
            total
          }
        }
        __typename
      }
      accessorInfo(includeGroups: true) {
        accessors {
          ... on Group {
            id
            emoji
            groupName: name
          }
          ... on Person {
            id
            name
            email
            avatarUrl
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          total
        }
      }
      sharingEnabled
      __typename
    }
  }
`;

// For plus button share window
export const NodeFragmentWithoutGroups = gql`
  fragment nodeResults on NodeType {
    ... on Node {
      id
      title
      baseUrl
      url
      modified
      created
      integrationType
      category
      owners {
        id
        name
        email
        avatarUrl
      }
      shareTargets {
        nodeId @client
        groupTargets(first: 200) {
          nodeId @client
          targets {
            ... on ShareTargetGroup {
              __typename
              id
              emoji
              groupName: name
            }
            nodeId
          }
          pageInfo {
            total
          }
        }
        orgPeopleTargets(first: 200) {
          nodeId @client
          targets {
            ... on Person {
              __typename
              id
              name
              avatarUrl
            }
            nodeId @client
            isOrgMember
          }
          pageInfo {
            total
          }
        }
        otherPeopleTargets(first: 200) {
          nodeId @client
          targets {
            ... on Person {
              __typename
              id
              name
              avatarUrl
            }
            nodeId @client
            isOrgMember
          }
          pageInfo {
            total
          }
        }
        __typename
      }
      accessorInfo(includeGroups: false) {
        accessors {
          ... on Group {
            id
            emoji
            groupName: name
          }
          ... on Person {
            id
            name
            email
            avatarUrl
          }
        }
        pageInfo {
          endCursor
          hasNextPage
          total
        }
      }
      sharingEnabled
      __typename
    }
  }
`;
